(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesktop = window.matchMedia('(min-width: 990px)');

  function setupSection(section) {
    if (section.__stepsVideoInit) return;
    section.__stepsVideoInit = true;

    var videos = Array.prototype.slice.call(section.querySelectorAll('.brand-steps__card video'));
    if (!videos.length) return;

    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.volume = 0;
    });

    if (reduce) return;

    if ('IntersectionObserver' in window) {
      var preloadIO = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            videos.forEach(function (v) {
              try { v.load(); } catch (err) {}
            });
            preloadIO.disconnect();
            break;
          }
        }
      }, { rootMargin: '800px 0px' });
      preloadIO.observe(section);
    }

    var mode = null;
    var current = -1;
    var sectionVisible = false;
    var ratios = [];
    var pendingGesture = false;

    function bindGesture(retry) {
      if (pendingGesture) return;
      pendingGesture = true;
      var evts = ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'];
      function onG() {
        evts.forEach(function (e) { window.removeEventListener(e, onG, true); });
        pendingGesture = false;
        retry();
      }
      evts.forEach(function (e) { window.addEventListener(e, onG, { capture: true, passive: true }); });
    }

    function safePlay(v) {
      try {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () { bindGesture(ensureCurrent); });
      } catch (e) {
        bindGesture(ensureCurrent);
      }
    }

    function pauseAll(except) {
      videos.forEach(function (v, i) {
        if (i !== except && !v.paused) v.pause();
      });
    }

    function ensureCurrent() {
      if (!sectionVisible) return;
      if (mode === 'sequential') {
        if (current >= 0) safePlay(videos[current]);
        else playSequential(0);
      } else {
        updateFocus(true);
      }
    }

    function playSequential(i) {
      if (!sectionVisible) return;
      current = ((i % videos.length) + videos.length) % videos.length;
      pauseAll(current);
      var v = videos[current];
      v.loop = false;
      try { v.currentTime = 0; } catch (e) {}
      safePlay(v);
    }

    function onEndedSeq() {
      if (mode !== 'sequential') return;
      playSequential(current + 1);
    }

    function updateFocus(force) {
      if (!sectionVisible) return;
      var best = -1, bestRatio = 0;
      for (var i = 0; i < videos.length; i++) {
        if (ratios[i] > bestRatio) { bestRatio = ratios[i]; best = i; }
      }
      if (best === -1) { pauseAll(-1); current = -1; return; }
      if (best !== current) {
        current = best;
        pauseAll(current);
        videos[current].loop = true;
        safePlay(videos[current]);
      } else if (force && videos[current].paused) {
        safePlay(videos[current]);
      }
    }

    var sectionIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sectionVisible = e.isIntersecting; });
      if (!sectionVisible) {
        pauseAll(-1);
      } else if (mode === 'sequential') {
        playSequential(current < 0 ? 0 : current);
      } else {
        updateFocus(false);
      }
    }, { threshold: 0.15 });
    sectionIO.observe(section);

    var videoIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var idx = videos.indexOf(e.target);
        if (idx >= 0) ratios[idx] = e.isIntersecting ? e.intersectionRatio : 0;
      });
      if (mode === 'focus') updateFocus(false);
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    videos.forEach(function (v) { videoIO.observe(v); });

    function setMode(desktop) {
      var next = desktop ? 'sequential' : 'focus';
      if (next === mode) return;
      mode = next;
      pauseAll(-1);
      current = -1;
      videos.forEach(function (v) {
        v.removeEventListener('ended', onEndedSeq);
        if (mode === 'sequential') {
          v.loop = false;
          v.addEventListener('ended', onEndedSeq);
        } else {
          v.loop = true;
        }
      });
      if (sectionVisible) {
        if (mode === 'sequential') playSequential(0);
        else updateFocus(false);
      }
    }

    setMode(mqDesktop.matches);
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', function (e) { setMode(e.matches); });
    else if (mqDesktop.addListener) mqDesktop.addListener(function (e) { setMode(e.matches); });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('.brand-steps');
    for (var i = 0; i < list.length; i++) setupSection(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
